import { useState, useRef, useEffect } from 'react';

import NewsletterRegistrationPage from 'components/newsletter-registration-page/NewsletterRegistrationPage';

import { INewsletterCrmRegistrationPage } from 'source/NFR.types';

const NewsletterCrmRegistrationPage: React.FC<INewsletterCrmRegistrationPage> = ({ registrationPage }) => {
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [isChecked, setIsChecked] = useState(true);
  const [triedSubmitting, setTriedSubmitting] = useState(false);
  const [offsetTop, setOffsetTop] = useState(0);

  const messageRef = useRef<HTMLDivElement>(null);

  const showEmailError = !isValidEmail && triedSubmitting;
  const showFormError = !isChecked && triedSubmitting;

  const onSubmit = (e: React.FormEvent) => {
    if (!isChecked || !isValidEmail) {
      setTriedSubmitting(true);
      e.preventDefault();
      if (!isChecked) window.scrollTo(0, offsetTop);
    }
  };

  useEffect(() => {
    if (messageRef.current) {
      setOffsetTop(messageRef.current.offsetTop);
    }
  }, [isChecked]);

  return (
    <div className="newsletter-crm-registration-page">
      <NewsletterRegistrationPage
        {...registrationPage}
        setIsValidEmail={setIsValidEmail}
        onSubmit={onSubmit}
        showFormError={showFormError}
        showEmailError={showEmailError}
        setIsChecked={setIsChecked}
        ref={messageRef}
      />
    </div>
  );
};

NewsletterCrmRegistrationPage.displayName = 'NewsletterCrmRegistrationPage';

export default NewsletterCrmRegistrationPage;
